import NativeSafeSelect from "../ui/NativeSafeSelect.jsx";

import {
  PASSENGER_ASSET_TYPES,
  PASSENGER_SERVICES,
  passengerAssetLabel,
  passengerServiceLabel,
  performerText,
} from "./performerCatalog.js";

export default function PassengerAssetFields({
  form,
  setForm,
  setError,
  language,
  inputStyle,
  labelStyle,
}) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  return (
    <>
      <div style={labelStyle}>
        {tx(
          "Вид транспорта",
          "Транспорт тури",
          "Araç türü"
        )}
      </div>

      <NativeSafeSelect
        value={form.assetType}
        onChange={(value) => {
          setError("");

          setForm((prev) => ({
            ...prev,
            assetType:
              String(value || "").toUpperCase(),
          }));
        }}
        style={{ ...inputStyle, color: "white" }}
        ariaLabel={tx(
          "Вид пассажирского транспорта",
          "Йўловчи транспорти тури",
          "Yolcu aracı türü"
        )}
        options={
          PASSENGER_ASSET_TYPES.map((value) => ({
            value,
            label:
              passengerAssetLabel(
                value,
                language
              ),
          }))
        }
      />

      <div style={labelStyle}>
        {tx(
          "Количество мест",
          "Ўриндиқлар сони",
          "Koltuk sayısı"
        )}
      </div>

      <input
        type="number"
        inputMode="numeric"
        min="1"
        max="100"
        step="1"
        placeholder="4"
        value={form.seats}
        onChange={(event) => {
          setError("");

          setForm((prev) => ({
            ...prev,
            seats: event.target.value,
          }));
        }}
        style={inputStyle}
      />

      <div style={labelStyle}>
        {tx(
          "Какие заказы вы выполняете?",
          "Қайси буюртмаларни бажарасиз?",
          "Hangi işleri yapıyorsunuz?"
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 8,
        }}
      >
        {PASSENGER_SERVICES.map((service) => {
          const current = Array.isArray(form.passengerServices)
            ? form.passengerServices
            : [];
          const active = current.includes(service);

          return (
            <button
              key={service}
              type="button"
              aria-pressed={active}
              onClick={() => {
                setError("");
                setForm((prev) => {
                  const selected = Array.isArray(prev.passengerServices)
                    ? prev.passengerServices
                    : [];
                  return {
                    ...prev,
                    passengerServices: selected.includes(service)
                      ? selected.filter((item) => item !== service)
                      : [...selected, service],
                  };
                });
              }}
              style={{
                border: active
                  ? "1px solid #3b82f6"
                  : "1px solid #334155",
                background: active
                  ? "#2563eb"
                  : "rgba(30,41,59,.82)",
                color: active ? "white" : "#e2e8f0",
                borderRadius: 999,
                padding: "10px 13px",
                fontWeight: 800,
              }}
            >
              {passengerServiceLabel(service, language)}
            </button>
          );
        })}
      </div>
    </>
  );
}
